import React, { useState, useEffect, Fragment } from "react";
import moment from "moment";
import { Form, Radio, Checkbox, DatePicker, Input, Select } from "antd";
import Api from "../../services/ServiceApi";
const { Option } = Select;

function GenDynamic(props) {
  const [dataMasFormJson, setDataMasFormJson] = useState({});
  useEffect(() => {
    console.log("=========================");
    console.log(props);
    console.log("=========================");
    function setFormsView(data) {
      const form_json = [];
      const form_json_parse = JSON.parse(data["form_json"]);
      for (let x in form_json_parse[data["table_name"]]) {
        form_json.push(form_json_parse[data["table_name"]][x]);
      }
      return form_json;
    }

    function setConditions(data) {
      let option = data.split(",");
      let options = [];
      for (let i = 0; i < option.length; i++) {
        let _option = option[i].split("=");
        options.push({
          column_name: _option[0],
          value: _option[1],
        });
      }
      return options;
    }

    async function fetchData() {
      const result = await Api.Get("get_mas_form_json",  props.department_id);
      if (result.data.result.code === "P") {
        const data = result["data"]["data"]["mas_form_json_dto_list"];
        if (data.length > 0) {
          const dataMasFormJson = data[0];
          if (
            dataMasFormJson["expire_date"] !== "" &&
            dataMasFormJson["expire_date"] !== null
          ) {
            dataMasFormJson["expire_date"] = moment(
              dataMasFormJson["expire_date"],
              "YYYY/MM/DD"
            );
          }
          dataMasFormJson["condition"] = setConditions(
            dataMasFormJson["data_roles"]
          );
          dataMasFormJson["forms"] = setFormsView(dataMasFormJson);
          dataMasFormJson["language_name"] = dataMasFormJson[
            "language_name"
          ].split(",");
          dataMasFormJson["language"] = dataMasFormJson["language"].split(",");
          console.log(dataMasFormJson);
          setDataMasFormJson(dataMasFormJson);

          // this.setState({
          //     dataMasFormJson,
          // }, () => {
          //     this.setState({ visibleView });
          // });
        } else {
          //this.setState({ visibleView });
        }
      } else {
      }
    }

    fetchData();
  }, []);

  const forms =
    dataMasFormJson.forms !== undefined ? dataMasFormJson.forms : [];

  return (
    <Fragment>
      {forms.map((field, index) => {
        if (field.input !== undefined) {
          if (field.input["type"] === "radio") {
            return (
              <Form.Item
                key={index}
                name={field.label["EN"]["for"]}
                label={field.label["EN"]["text"]}
                rules={[
                  {
                    required: field.input["required"],
                    message: `${field.label["EN"]["text"]} is required`,
                  },
                ]}
              >
                <Radio.Group options={field.option} />
              </Form.Item>
            );
          } else if (field.input["type"] === "checkbox") {
            return (
              <Form.Item
                key={index}
                name={field.label["EN"]["for"]}
                label={field.label["EN"]["text"]}
                rules={[
                  {
                    required: field.input["required"],
                    message: `${field.label["EN"]["text"]} is required`,
                  },
                ]}
              >
                <Checkbox.Group options={field.option} />
              </Form.Item>
            );
          } else if (field.input["type"] === "date") {
            return (
              <Form.Item
                key={index}
                name={field.label["EN"]["for"]}
                label={field.label["EN"]["text"]}
                rules={[
                  {
                    required: field.input["required"],
                    message: `${field.label["EN"]["text"]} is required`,
                  },
                ]}
              >
                <DatePicker format="DD/MM/YYYY" />
              </Form.Item>
            );
          } else if (field.input["type"] === "datetime-local") {
            return (
              <Form.Item
                key={index}
                name={field.label["EN"]["for"]}
                label={field.label["EN"]["text"]}
                rules={[
                  {
                    type: "object",
                    required: field.input["required"],
                    message: `${field.label["EN"]["text"]} is required`,
                  },
                ]}
              >
                <DatePicker showTime format="DD/MM/YYYY HH:mm:ss" />
              </Form.Item>
            );
          } else if (field.input["type"] === "password") {
            return (
              <Form.Item
                key={index}
                name={field.label["EN"]["for"]}
                label={field.label["EN"]["text"]}
                rules={[
                  {
                    type: "object",
                    required: field.input["required"],
                    message: `${field.label["EN"]["text"]} is required`,
                  },
                ]}
              >
                <Input.Password
                  placeholder={`Please input ${field.label["EN"][
                    "text"
                  ].toLowerCase()}`}
                />
              </Form.Item>
            );
          } else {
            return (
              <Form.Item
                key={index}
                name={field.label["EN"]["for"]}
                label={field.label["EN"]["text"]}
                rules={[
                  {
                    required: field.input["required"],
                    message: `${field.label["EN"]["text"]} is required`,
                  },
                ]}
              >
                <Input
                  type={field.input["type"]}
                  className="font-mont-r fs-12"
                  size="large"
                  placeholder={`Please input ${field.label["EN"][
                    "text"
                  ].toLowerCase()}`}
                  pattern={
                    field.input["pattern"] !== undefined
                      ? field.input["pattern"]
                      : ""
                  }
                />
              </Form.Item>
            );
          }
        } else if (field.select !== undefined) {
          const options = field.option.map((d) => (
            <Option key={d.value}>{d.label}</Option>
          ));
          return (
            <Form.Item
              key={index}
              name={field.label["EN"]["for"]}
              label={field.label["EN"]["text"]}
              rules={[
                {
                  required: field.select["required"],
                  message: `${field.select["text"]} is required`,
                },
              ]}
            >
              <Select
                className="font-mont-r fs-12"
                size="large"
                placeholder={`Please select ${field.label["EN"][
                  "text"
                ].toLowerCase()}`}
              >
                {options}
              </Select>
            </Form.Item>
          );
        } else if (field.textarea !== undefined) {
          return (
            <Form.Item
              key={index}
              name={field.label["EN"]["for"]}
              label={field.label["EN"]["text"]}
              rules={[
                {
                  required: field.textarea["required"],
                  message: `${field.textarea["text"]} is required`,
                },
              ]}
            >
              <Input.TextArea />
            </Form.Item>
          );
        }
      })}
    </Fragment>
  );
}

export default GenDynamic;
